const prefix = ''

export const tagsUrls = {
  'tag.list': `${prefix}/tags`,
}
